import { render, staticRenderFns } from "./CButtom.vue?vue&type=template&id=5c5488ee&scoped=true"
import script from "./CButtom.vue?vue&type=script&lang=js"
export * from "./CButtom.vue?vue&type=script&lang=js"
import style0 from "./CButtom.vue?vue&type=style&index=0&id=5c5488ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5488ee",
  null
  
)

export default component.exports